<div class="page-header" [ngClass]="{ close_icon: navService.collapseSidebar }">
  <div class="header-wrapper col m-0">
    <div class="row m-0 align-items-center justify-content-between justify-content-lg-center">
      <div class="header-logo-wrapper col-auto p-0">
        <div class="logo-wrapper">
          <a [routerLink]="['/']">
            <img class="header-logo" src="assets/images/logo/logo.svg" alt="" />
          </a>
        </div>
      </div>
      <!-- Bottone hamburger per mobile -->
      <button class="hamburger-menu d-lg-none btn" (click)="toggleMenu()">
        <i class="icon-menu"></i>
      </button>
      <div class="nav-right col-xxl-8 col-xl-6 col-md-7 col-8 pull-right right-header p-0 ms-auto" [ngClass]="{ 'menu-open-mobile': isMenuOpen }">
        <i class="icon-close d-lg-none" (click)="closeMenu()"></i>
        <div class="button-navbar">
          @if (isAdmin()) {
          <div>
            <button data-test="app-ida" class="btn btn-tertiary max-content" type="button" [routerLink]="['/admin/report']" routerLinkActive="active">
              {{ "routes.report" | translate }}
            </button>
          </div>
          }
          <div>
            <button data-test="app-ida" class="btn btn-tertiary max-content" type="button" [routerLink]="['/admin/customers']" routerLinkActive="active">
              {{ "routes.customers" | translate }}
            </button>
          </div>
          <div>
            <button data-test="app-events" class="btn btn-tertiary max-content" type="button" routerLinkActive="active" (click)="downloadHelp()">
              {{ "routes.help" | translate }}
            </button>
          </div>
          <div>
            <button data-test="app-profile" class="btn btn-tertiary max-content" type="button" routerLinkActive="active" [routerLink]="['/admin/profile']">
              {{ "routes.profile" | translate }}
            </button>
          </div>
          <!-- <div>
            <button data-test="app-events" class="btn btn-tertiary max-content" type="button" routerLinkActive="active">
              {{ "routes.customers" | translate }}
            </button>
          </div>
          <div>
            <button data-test="app-store" class="btn btn-tertiary max-content" type="button" routerLinkActive="active">
              {{ "routes.stores" | translate }}
            </button>
          </div>
          <div>
            <button data-test="app-checkin" class="btn btn-tertiary max-content" type="button" routerLinkActive="active">
              {{ "routes.check-in" | translate }}
            </button>
          </div>
          <div>
            <button data-test="app-profile" class="btn btn-tertiary max-content" type="button" routerLinkActive="active">
              {{ "routes.profile" | translate }}
            </button>
          </div>
          <div *ngIf="isRoleAdmin()">
            <button data-test="new-event-button" class="btn btn-primary max-content" type="button" routerLinkActive="active">
              {{ "routes.new_event" | translate }}
            </button>
          </div> -->
          <div>
            <app-language-switcher />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <app-breadcrumb (customerAdded)="onCustomerAdded($event)"></app-breadcrumb>
  </div>
</div>
